export default __webpack_public_path__ + "static/media/IMG_9877.3cb491d7.jpg";